var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCirclePlay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.25C0 7.05078 1.6875 4.09766 4.5 2.48047C7.27734 0.863281 10.6875 0.863281 13.5 2.48047C16.2773 4.09766 18 7.05078 18 10.25C18 13.4844 16.2773 16.4375 13.5 18.0547C10.6875 19.6719 7.27734 19.6719 4.5 18.0547C1.6875 16.4375 0 13.4844 0 10.25ZM6.60938 6.45312C6.32812 6.59375 6.1875 6.875 6.1875 7.15625V13.3438C6.1875 13.6602 6.32812 13.9414 6.60938 14.082C6.85547 14.2578 7.20703 14.2227 7.45312 14.082L12.5156 10.9883C12.7617 10.8125 12.9375 10.5664 12.9375 10.25C12.9375 9.96875 12.7617 9.6875 12.5156 9.54688L7.45312 6.45312C7.20703 6.27734 6.85547 6.27734 6.60938 6.41797V6.45312Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlay);
export default __webpack_public_path__ + "static/media/circlePlay.0593b28e9c02f7b56ffba5e118ba7b9e.svg";
export { ForwardRef as ReactComponent };